module.exports = __webpack_public_path__ + "img/compartir.f415192d.svg";